import { render, staticRenderFns } from "./PsReportsAltasBajas.vue?vue&type=template&id=7bbc2f06&scoped=true&"
import script from "./PsReportsAltasBajas.vue?vue&type=script&lang=js&"
export * from "./PsReportsAltasBajas.vue?vue&type=script&lang=js&"
import style0 from "./PsReportsAltasBajas.vue?vue&type=style&index=0&id=7bbc2f06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbc2f06",
  null
  
)

export default component.exports